import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import Box from "../../Box";
import { BasePrimitiveSkeletonBox } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function PrimitiveSkeletonBox(_ref) {
  var restProps = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(Box, _extends({}, restProps, {
    children: /*#__PURE__*/_jsx(BasePrimitiveSkeletonBox, {})
  }));
}
export default PrimitiveSkeletonBox;